import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import {
  NbAlertModule,
  NbButtonModule,
  NbCheckboxModule,
  NbIconModule,
  NbInputModule,
} from '@nebular/theme';
import { LetDirective } from '@ngrx/component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { CommonLoginComponent } from './components/common-login.component';
import { DebugComponent } from './components/debug.component';
import { MatTableResponsiveDirective } from './directives/mat-table-responsive.directive';
import { TypeSafeMatCellDef } from './directives/type-safe-mat-cell-def.directive';
import { AddressFormatPipe } from './pipes/address-format.pipe';
import { ClientFormattedNamePipe } from './pipes/client-formatted-name.pipe';
import { EnumClientTypePipe } from './pipes/enum-client-type.pipe';
import { EnumPermitStatusColorPipe } from './pipes/enum-permit-status-color.pipe';
import { EnumProjectJobContractTypePipe } from './pipes/enum-project-job-contract-type.pipe';
import { EnumProjectJobPermitStatusPipe } from './pipes/enum-project-job-permit-status.pipe';
import { EnumProjectJobPermitTypePipe } from './pipes/enum-project-job-permit-type.pipe';
import { EnumProjectJobStatusColorPipe } from './pipes/enum-project-job-status-color.pipe';
import { EnumProjectJobStatusPipe } from './pipes/enum-project-job-status.pipe';
import { EnumProjectJobTypePipe } from './pipes/enum-project-job-type.pipe';
import { EnumProjectStakingTypePipe } from './pipes/enum-project-staking-type.pipe';
import { EnumProjectSurveyTaskTypePipe } from './pipes/enum-project-survey-task-type.pipe';
import { EnumProjectTaxLocationPipe } from './pipes/enum-project-tax-location.pipe';
import { EnumUserRolePipe } from './pipes/enum-user-role.pipe';
import { FormattedHoursPipe } from './pipes/formatted-hours.pipe';
import { PbDatePipe } from './pipes/pb-date.pipe';
import { TimeTrackingTaskPipe } from './pipes/time-tracking-task.pipe';

@NgModule({
  declarations: [
    AddressFormatPipe,
    CommonLoginComponent,
    EnumClientTypePipe,
    EnumProjectJobContractTypePipe,
    EnumProjectJobPermitStatusPipe,
    EnumProjectJobPermitTypePipe,
    EnumProjectStakingTypePipe,
    EnumProjectJobStatusPipe,
    EnumProjectJobTypePipe,
    EnumProjectSurveyTaskTypePipe,
    EnumProjectTaxLocationPipe,
    EnumUserRolePipe,
    PbDatePipe,
    ClientFormattedNamePipe,
    TimeTrackingTaskPipe,
    DebugComponent,
    TypeSafeMatCellDef,
    EnumProjectJobStatusColorPipe,
    EnumPermitStatusColorPipe,
    MatTableResponsiveDirective,
    FormattedHoursPipe,
  ],
  exports: [
    AddressFormatPipe,
    CommonLoginComponent,
    EnumClientTypePipe,
    EnumProjectJobContractTypePipe,
    EnumProjectJobPermitStatusPipe,
    EnumProjectJobPermitTypePipe,
    EnumProjectStakingTypePipe,
    EnumProjectJobStatusPipe,
    EnumProjectJobTypePipe,
    EnumProjectSurveyTaskTypePipe,
    EnumProjectTaxLocationPipe,
    EnumUserRolePipe,
    PbDatePipe,
    TimeTrackingTaskPipe,
    DebugComponent,
    TypeSafeMatCellDef,
    EnumProjectJobStatusColorPipe,
    EnumPermitStatusColorPipe,
    MatTableResponsiveDirective,
    FormattedHoursPipe,
  ],
  imports: [
    CommonModule,
    NbAlertModule,
    NbInputModule,
    FormsModule,
    RouterLink,
    NbButtonModule,
    NbIconModule,
    NbCheckboxModule,
    MatInputModule,
    ReactiveFormsModule,
    LetDirective,
    NgxJsonViewerModule,
  ],
})
export class UICommonModule {}
